import React from 'react'
import {
  Form,
  Input,
  Button,
  Select,
  Checkbox,
  InputNumber,
  Collapse,
  Typography
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'

// Английские поля задания (kazlingo, X-App-Language: en).
// Общие для всех типов, в том числе тех, у которых нет своей формы
// (listenAudioChooseWord, translateWord, listeningAndTranslation и т.п.).
// Всё необязательно: без EN сервер отдаёт русский.
//
// - correctTextEn / translateTextEn / typeTextEn — строки
// - variants[].textEn — перевод каждого существующего варианта
// - variantsEn — полный массив вариантов для EN-режима (заменяет variants целиком)
// - correctVariantsEn — правильные ответы на английском
// - correctMatchesEn — пары "A~B" для matchWords (подставляются вместе с column*.textEn)

const EnglishFields = ({ form }) => (
  <Collapse ghost style={{ marginBottom: 16 }}>
    <Collapse.Panel
      header="English (EN) — перевод задания, необязательно"
      key="en"
      forceRender
    >
      <Form.Item name="correctTextEn" label="correctTextEn">
        <Input placeholder="English" />
      </Form.Item>
      <Form.Item name="translateTextEn" label="translateTextEn">
        <Input placeholder="English" />
      </Form.Item>
      <Form.Item name="typeTextEn" label="typeTextEn">
        <Input placeholder="e.g. Match the words" />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {() => {
          const variants = form.getFieldValue('variants') || []
          if (!variants.length) return null
          return (
            <>
              <Typography.Text strong>variants[].textEn</Typography.Text>
              {variants.map((variant, index) => (
                <Form.Item
                  key={`variant-en-${index}`}
                  name={['variants', index, 'textEn']}
                  label={`${index + 1}. ${variant?.text || ''}`}
                >
                  <Input placeholder="English" />
                </Form.Item>
              ))}
            </>
          )
        }}
      </Form.Item>

      <Form.Item
        name="correctVariantsEn"
        label="correctVariantsEn (Enter — добавить вариант)"
      >
        <Select mode="tags" open={false} placeholder="Correct answers" />
      </Form.Item>

      <Form.Item
        name="correctMatchesEn"
        label="correctMatchesEn (пары «A~B» для matchWords)"
      >
        <Select mode="tags" open={false} placeholder="word~translation" />
      </Form.Item>

      <Typography.Text strong>
        variantsEn — полный набор вариантов для EN (заменяет variants целиком)
      </Typography.Text>
      <Form.List name="variantsEn">
        {(fields, { add, remove }) => (
          <>
            {fields.map((field, index) => (
              <div
                key={field.key}
                style={{
                  display: 'flex',
                  gap: 8,
                  alignItems: 'flex-start',
                  marginTop: 8
                }}
              >
                <Form.Item
                  name={[field.name, 'text']}
                  style={{ flex: 1, marginBottom: 0 }}
                  rules={[{ required: true, message: 'Введите текст' }]}
                >
                  <Input placeholder={`Variant ${index + 1}`} />
                </Form.Item>
                <Form.Item
                  name={[field.name, 'isCorrect']}
                  valuePropName="checked"
                  style={{ marginBottom: 0 }}
                >
                  <Checkbox>isCorrect</Checkbox>
                </Form.Item>
                <Form.Item
                  name={[field.name, 'correctIndex']}
                  style={{ marginBottom: 0 }}
                >
                  <InputNumber placeholder="correctIndex" min={0} />
                </Form.Item>
                <Button type="dashed" onClick={() => remove(field.name)}>
                  Удалить
                </Button>
              </div>
            ))}
            <Button
              type="dashed"
              onClick={() => add()}
              style={{ width: '100%', marginTop: 8 }}
            >
              <PlusOutlined /> Добавить EN-вариант
            </Button>
          </>
        )}
      </Form.List>
    </Collapse.Panel>
  </Collapse>
)

// Поля, которые processAssessmentData сериализует как JSON
export const EN_ARRAY_FIELDS = [
  'variantsEn',
  'correctVariantsEn',
  'correctMatchesEn'
]
export const EN_STRING_FIELDS = [
  'correctTextEn',
  'translateTextEn',
  'typeTextEn'
]

// variantsEn: убираем пустые значения, imageUrl/audioUrl с исходных вариантов
// не трогаем — их сервер берёт из variants, если в EN-варианте их нет
export const cleanVariantsEn = variantsEn =>
  (variantsEn || [])
    .filter(v => v && v.text)
    .map(({ text, isCorrect, correctIndex, imageUrl, audioUrl }) => ({
      text,
      ...(isCorrect !== undefined && { isCorrect: !!isCorrect }),
      ...(correctIndex !== undefined &&
        correctIndex !== null && { correctIndex }),
      ...(imageUrl && { imageUrl }),
      ...(audioUrl && { audioUrl })
    }))

export default EnglishFields
